module.exports = __webpack_public_path__ + "img/MDMDPFQ09QT8.92093395.png";